import React from 'react';

import SliceLogo from './logo';

import './index.css';

interface Props {
    title: string;
    description: string;
}

const Header: React.FC<Props> = ({ title, description }) => {
    return (
        <div className="header-wrapper">
            <SliceLogo className="header-logo" />
            <h1 className="header-title">{title}</h1>

            <p className="header-description">{description}</p>
        </div>
    );
};

export default Header;
